import type { CSSProperties } from 'react';
import styled, { type DefaultTheme } from 'styled-components';

export const TaskSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  min-width: 0;
`;

export const TaskError = styled.div`
  padding: ${({ theme }) => theme.spacing.sm}px
    ${({ theme }) => theme.spacing.md}px;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  background: ${({ theme }) => theme.colors.red_5};
`;

export const TaskPagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TaskDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;

export const TaskDrawerHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const TaskDrawerCloseButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.transparent};
  border: 0;
  color: ${({ theme }) => theme.colors.grey_1};
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0;
`;

export const TaskDrawerFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;

export const TaskDrawerFormStyles = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-label {
    padding-bottom: ${({ theme }) => theme.spacing.sm}px;
  }

  .ant-form-item-label > label {
    color: ${({ theme }) => theme.colors.grey_1};
    font-size: ${({ theme }) => theme.fonts.body2};
    height: auto;
    line-height: ${({ theme }) => theme.fontsLineHeights.body2};
  }

  .ant-input {
    background: ${({ theme }) => theme.colors.grey_5};
    border-color: ${({ theme }) => theme.colors.grey_4};
    border-radius: ${({ theme }) => theme.border_radius.sm};
    color: ${({ theme }) => theme.colors.grey_1};
    font-size: ${({ theme }) => theme.fonts.body2};
    line-height: ${({ theme }) => theme.fontsLineHeights.body3};
    min-height: ${({ theme }) => theme.spacing.xl + theme.spacing.xs}px;
    padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  }

  .ant-input:hover,
  .ant-input:focus {
    border-color: ${({ theme }) => theme.colors.grey_4};
    box-shadow: none;
  }

  textarea.ant-input {
    min-height: ${({ theme }) => theme.spacing.xxxl + theme.spacing.sm}px;
    resize: none;
  }
`;

export const TaskDrawerReadOnlySelect = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.grey_5};
  border: thin solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  display: flex;
  min-height: ${({ theme }) => theme.spacing.xl + theme.spacing.xs}px;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
`;

export const TaskDrawerMetaList = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;

export const getTaskDrawerStyles = (
  theme: DefaultTheme,
): Partial<Record<'content' | 'header' | 'body', CSSProperties>> => ({
  content: { background: theme.colors.white_1 },
  header: {
    padding: theme.spacing.lg,
    borderBottom: `thin solid ${theme.colors.grey_4}`,
    background: theme.colors.beige_3,
  },
  body: {
    padding: theme.spacing.lg,
    background: theme.colors.white_1,
  },
});
